import React from 'react';
import { Wallet, ArrowDownLeft, Clock, CheckCircle2, Download, Filter } from 'lucide-react';
const history = [{
  id: 'PO-9901',
  date: 'Oct 14, 2023',
  amount: 4200,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}, {
  id: 'PO-9900',
  date: 'Oct 01, 2023',
  amount: 3150,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}, {
  id: 'PO-9899',
  date: 'Sep 15, 2023',
  amount: 2800,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}];
export function Payouts() {
  return <div className="space-y-6 max-w-[1600px] mx-auto" data-id="element-2296">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-2297">
        <div data-id="element-2298">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-2299">Partner Payouts</h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-2300">
            Withdraw your earnings and manage settlement frequency.
          </p>
        </div>
        <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-2301">
          <ArrowDownLeft size={18} data-id="element-2302" />
          Request Instant Payout
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2303">
        <div className="bg-slate-900 p-6 rounded-lg text-white" data-id="element-2304">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-2305">
            Available for Withdrawal
          </p>
          <h3 className="text-3xl font-bold" data-id="element-2306">$12,450.00</h3>
          <div className="mt-4 flex items-center gap-2 text-xs font-bold text-indigo-400" data-id="element-2307">
            <Clock size={14} data-id="element-2308" />
            <span data-id="element-2309">Next auto-payout in 3 days</span>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-2310">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-2311">
            Total Withdrawn (YTD)
          </p>
          <h3 className="text-3xl font-bold text-slate-900" data-id="element-2312">$84,200.00</h3>
          <p className="mt-4 text-xs font-bold text-emerald-600 flex items-center gap-1" data-id="element-2313">
            <CheckCircle2 size={14} data-id="element-2314" /> 12 Successful Payouts
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-2315">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-2316">
            Pending Clearance
          </p>
          <h3 className="text-3xl font-bold text-slate-900" data-id="element-2317">$5,120.00</h3>
          <div className="mt-4 w-full bg-gray-100 h-1.5 rounded-full overflow-hidden" data-id="element-2318">
            <div className="h-full bg-indigo-600 w-2/3" data-id="element-2319"></div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2320">
        <div className="p-6 border-b border-gray-100 flex items-center justify-between bg-gray-50/50" data-id="element-2321">
          <h3 className="font-bold text-slate-900" data-id="element-2322">Payout History</h3>
          <div className="flex gap-2" data-id="element-2323">
            <button className="p-2 text-gray-400 hover:text-slate-600 transition-colors" data-id="element-2324">
              <Filter size={18} data-id="element-2325" />
            </button>
            <button className="p-2 text-gray-400 hover:text-slate-600 transition-colors" data-id="element-2326">
              <Download size={18} data-id="element-2327" />
            </button>
          </div>
        </div>
        <table className="w-full text-left border-collapse" data-id="element-2328">
          <thead data-id="element-2329">
            <tr className="text-[10px] font-bold uppercase tracking-wider text-gray-400 border-b border-gray-100" data-id="element-2330">
              <th className="px-6 py-4" data-id="element-2331">Payout ID</th>
              <th className="px-6 py-4" data-id="element-2332">Date</th>
              <th className="px-6 py-4" data-id="element-2333">Amount</th>
              <th className="px-6 py-4" data-id="element-2334">Method</th>
              <th className="px-6 py-4" data-id="element-2335">Status</th>
            </tr>
          </thead>
          <tbody className="text-sm" data-id="element-2336">
            {history.map(h => <tr key={h.id} className="hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0" data-id="element-2337">
                <td className="px-6 py-4 font-bold text-slate-900" data-id="element-2338">{h.id}</td>
                <td className="px-6 py-4 text-gray-500" data-id="element-2339">{h.date}</td>
                <td className="px-6 py-4 font-bold text-slate-900" data-id="element-2340">
                  ${h.amount.toLocaleString()}.00
                </td>
                <td className="px-6 py-4 text-gray-500 font-medium" data-id="element-2341">
                  {h.method}
                </td>
                <td className="px-6 py-4" data-id="element-2342">
                  <span className="px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-emerald-50 text-emerald-600" data-id="element-2343">
                    {h.status}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}